/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch } from 'react-router-dom';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { ReferenceContainer } from './data/ReferenceContainer';
import { ReferenceSearchPage } from './search/ReferenceSearchPage';
import { ReferenceEditPage } from './edit/ReferenceEditPage';
import { ReferenceInfoPage } from './info/ReferenceInfoPage';
import { withUser } from '../../auth/withUser';
import { isDataManager } from '../../../role/roleUtils';

const ReferenceUnwrapped = ({ basePath, authorities }) => {
  const dataManager = isDataManager(authorities);
  return (
    <Switch>
      <Route exact path={`${basePath}/info/:id`} component={ReferenceInfoPage} />
      {dataManager && <Route exact path={`${basePath}/data`} component={ReferenceContainer} />}
      {dataManager && <Route exact path={`${basePath}/search`} component={ReferenceSearchPage} />}
      {dataManager && (
      <Route
        exact
        path={`${basePath}/update/:id`}
        render={props => (
          <ReferenceEditPage key={props.match.params.id} {...props} />)}
      />
      )}
      {dataManager && (
      <Route
        exact
        path={`${basePath}/update`}
        render={props => (<ReferenceEditPage {...props} />)}
      />
      )}

      <Redirect to={dataManager ? `${basePath}/search` : '/about'} />
    </Switch>
  );
};

ReferenceUnwrapped.propTypes = {
  basePath: PropTypes.string.isRequired,
  authorities: ImmutablePropTypes.list.isRequired,
};

export const Reference = withUser(ReferenceUnwrapped);
